var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellWired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9716 2.55149C3.34346 2.19746 3.83723 2 4.35067 2H15.7015C16.2242 2 16.7262 2.20467 17.0999 2.57019L18.3984 3.84021C18.7832 4.21648 19 4.7319 19 5.27002V18C19 18.5523 18.5523 19 18 19H2.00001C1.44773 19 1.00001 18.5523 1.00001 18L1 5.28591C1 4.73844 1.22443 4.2149 1.62093 3.8374L2.9716 2.55149Z",
    fill: "#D5D5D5",
    stroke: "#AAAAAA",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.036 4.35059H2.16178C1.90393 4.35059 1.25 4.3953 1.25 5.19059V17.9106C1.25 18.7059 1.90393 18.7506 2.16178 18.7506H18.036C18.2938 18.7506 18.75 18.7059 18.75 17.9106V5.19059C18.75 4.3953 18.2938 4.35059 18.036 4.35059Z",
    fill: "url(#paint0_linear_5782_137940)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8145 5.52637C12.0904 5.52646 12.3143 5.75042 12.3145 6.02637V7.29004H15.9287C16.2048 7.29011 16.4287 7.51394 16.4287 7.79004V15.6064C16.4287 15.8825 16.2048 16.1064 15.9287 16.1064H4.07129C3.79525 16.1064 3.57135 15.8825 3.57129 15.6064V7.79004C3.57129 7.51394 3.79521 7.29011 4.07129 7.29004H7.68555V6.02637C7.68571 5.75042 7.90958 5.52646 8.18555 5.52637H11.8145Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40039 14.9307H5.37109V12.5791H6.40039V14.9307ZM8.45703 14.9307H7.42871V12.5791H8.45703V14.9307ZM10.5146 14.9307H9.48535V12.5791H10.5146V14.9307ZM12.5713 14.9307H11.543V12.5791H12.5713V14.9307ZM14.6289 14.9307H13.5996V12.5791H14.6289V14.9307Z",
    fill: "#EBAC57"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5782_137940",
    x1: 10.0988,
    y1: 4.35059,
    x2: 10.0988,
    y2: 18.7506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellWired);
export default __webpack_public_path__ + "static/media/icn_table_cell_wired.051216b2c11b384bbf3e6aea993ad0ff.svg";
export { ForwardRef as ReactComponent };